import useTranslation from 'next-translate/useTranslation';

export function Errors({ data }: any) {
  const { t } = useTranslation();
  const message =
    data?.message ||
    (data?.min ?? t('common:Value too low')) ||
    (data?.max ?? t('common:Value too high')) ||
    (data?.maxLenght ?? t('common:Too many letters'));
  return data ? (
    <div className='text-normal text-red-500 '>{message}</div>
  ) : null;
}
